var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceUnmatched(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.87,
    fillRule: "nonzero",
    d: "M7.5 8.76c.866 0 1.816.126 2.85.378 1.174.293 2.124.684 2.85 1.173.867.573 1.3 1.216 1.3 1.929V14H.5v-1.76c0-.713.433-1.356 1.3-1.929.726-.489 1.676-.88 2.85-1.173 1.034-.252 1.984-.378 2.85-.378zM7.5 7c-.629 0-1.209-.157-1.74-.472-.53-.314-.953-.737-1.267-1.268-.315-.53-.472-1.11-.472-1.739s.157-1.216.472-1.76C4.807 1.215 5.23.785 5.76.47 6.291.158 6.871 0 7.5 0s1.209.157 1.74.472c.53.314.953.744 1.267 1.288.315.545.472 1.132.472 1.761s-.157 1.209-.472 1.74c-.314.53-.737.953-1.267 1.267C8.709 6.843 8.129 7 7.5 7z",
    transform: "translate(-.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.5) translate(7.5 7)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.87,
    fillRule: "nonzero",
    d: "M4.328 6.518c.006-.373.048-.668.127-.885.078-.216.238-.456.48-.72l.616-.636c.264-.298.396-.618.396-.96 0-.33-.086-.588-.259-.774-.173-.187-.424-.28-.753-.28-.32 0-.578.084-.772.254-.195.17-.292.397-.292.682H3c.006-.508.188-.918.544-1.23.356-.313.82-.469 1.39-.469.594 0 1.056.16 1.387.478.331.318.497.755.497 1.31 0 .55-.254 1.091-.763 1.625l-.513.508c-.23.255-.344.62-.344 1.097h-.87zM4.29 8.01c0-.14.043-.26.13-.355.086-.096.213-.144.383-.144s.298.048.386.144c.088.096.132.214.132.355 0 .142-.044.259-.132.351-.088.093-.217.139-.386.139-.17 0-.297-.046-.384-.139-.086-.092-.13-.21-.13-.35z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceUnmatched);
export default __webpack_public_path__ + "static/media/face_unmatched.00a45bca533cdc71b0b3f958d8265f85.svg";
export { ForwardRef as ReactComponent };